
import { defineComponent, defineAsyncComponent, PropType } from 'vue';
import Message from '@/models/MessageModel';

export default defineComponent({
	name: 'answer-field',

	components: {
		default: defineAsyncComponent(() => import('./DefaultInput.vue')),
		phone: defineAsyncComponent(() => import('./PhoneInput.vue')),
		email: defineAsyncComponent(() => import('./EmailInput.vue')),
		numerical: defineAsyncComponent(() => import('./NumberInput.vue')),
		date: defineAsyncComponent(() => import('./DateInput.vue'))
	},

	props: {
		lastMessageQuestionType: {
			type: String,
			default: 'default'
		},

		isShow: {
			type: Boolean,
			default: false
		},
		message: {
			type: Object as PropType<Message> | null,
			default: null
		}
	},

	emits: ['send-message'],

	data() {
		return {
			// Нужно нам чтобы блокировать возможность
			// В моменте отправить несколько сообщений
			permissionOnSending: true as boolean
		};
	},

	computed: {
		// Определяем какой инпут показывать на основе вопроса от бота
		whatKindOfInputShow(): string {
			console.log(this.lastMessageQuestionType);

			switch (this.lastMessageQuestionType) {
				case 'phone_respondent':
					return 'phone';
				case 'mail_respondent':
					return 'email';
				case 'numerical':
					return 'numerical';
				case 'bdate_respondent':
					return 'date';
				case 'date_time':
					return 'date';
				default:
					return 'default';
			}
		},

		isPhoneSize(): boolean {
			return this.$q.screen.name === 'xs';
		}
	},

	methods: {
		sendMessage(text: string) {
			if (!this.permissionOnSending) {
				return;
			}

			this.$emit('send-message', { text });
			this.permissionOnSending = false;

			// Переводим фокус на скрытый инпут, чтобы не закрывалась клавиатура на телефоне
			this.setFocusOnInput('hidden');
		},

		setFocusOnInput(ref: string) {
			setTimeout(() => {
				const input = this.$refs[ref] as HTMLInputElement;
				if (input) {
					input.focus();
					this.permissionOnSending = true;
				}
			}, 0);
		}
	}
});
